import { grey } from '@material-ui/core/colors';
const grey100 = grey[100];

const paddingLeftDrawerOpen = 250;
const styles = (currentTheme, width, navDrawerOpen) => ({
  header: {
    paddingLeft: navDrawerOpen ? paddingLeftDrawerOpen : 0,
  },
  settingDrawer: {
    backgroundColor: currentTheme.logoBackgroundColor,
    color: currentTheme.logoColor,
  },
  container: {
    // backgroundColor: grey100,
    backgroundColor: grey100,
    // marginTop: '57px',
    height: '93vh',
    paddingRight: 20,
    paddingLeft: 20,
    // paddingLeft: navDrawerOpen && width !== SMALL ? paddingLeftDrawerOpen : 20,
    paddingBottom: 0,
    overflow: 'auto'

  },
  themeOptions: {
    paddingTop: 10,
    paddingLeft: 25,
  },
  radioButton: {
    marginBottom: 16,
  },
  radioButtonLabel: {
    color: currentTheme.settingsOptionsColor,
  },
  headerItem: {
    color: currentTheme.headerItemColor,
    fontSize: 14,
    backgroundColor: currentTheme.headerItemBackgroundColor,
    fontWeight: currentTheme.headerItemFontWeight,
    textAlign: 'center',
    paddingTop: 10,
    paddingBottom: 10,
  },
  swithStyle: {
    paddingLeft: 25,
    width: 180,
  },
  swithColor: {
    color: currentTheme.settingsOptionsColor,
  },

});

export default styles;
